import { render, staticRenderFns } from "./jobItemPerson.vue?vue&type=template&id=c64ef692&scoped=true"
import script from "./jobItemPerson.vue?vue&type=script&lang=js"
export * from "./jobItemPerson.vue?vue&type=script&lang=js"
import style0 from "./jobItemPerson.vue?vue&type=style&index=0&id=c64ef692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ef692",
  null
  
)

export default component.exports